/* ---------------------------------------------------------------------------
   NQ.FI - Kusmi-style rating badge on product cards.

   Moves the theme's rating (which renders as 5 star glyphs + "3.33 / 5.0" + "(3)"
   under the price) into a compact badge overlaid on the top-left of the card image:

       * 4.7 (2555)

   Done in JS rather than by editing snippets/card-product.liquid, so that vendor
   theme upgrades cannot remove it - same reasoning as the nq-* snippets. The
   trade-off is a brief flash before the badge is built.

   The original rating cluster is hidden via CSS only once the badge exists
   (.nq-has-rating-badge), so if this script fails the theme's own rating still
   shows rather than disappearing.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var STAR =
    '<svg class="nq-card-rating__star" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.5l2.9 6.1 6.6.9-4.8 4.6 1.2 6.6L12 17.6 6.1 20.7l1.2-6.6L2.5 9.5l6.6-.9z"/></svg>';

  function parseRating(card) {
    // Preferred: the aria-label on .rating, e.g. "3.33 / 5.0 tahtea"
    var el = card.querySelector('.rating[aria-label]');
    var raw = el && el.getAttribute('aria-label');

    if (!raw) {
      var t = card.querySelector('.rating-text [aria-hidden], .rating-text');
      raw = t && t.textContent;
    }
    if (!raw) return null;

    var m = raw.replace(',', '.').match(/([0-9]+(?:\.[0-9]+)?)/);
    if (!m) return null;

    var value = parseFloat(m[1]);
    if (isNaN(value)) return null;

    var count = '';
    var c = card.querySelector('.rating-count [aria-hidden], .rating-count');
    if (c) {
      var cm = c.textContent.replace(/\s/g, '').match(/([0-9]+)/);
      if (cm) count = cm[1];
    }

    return { value: value, count: count };
  }

  function decorate(card) {
    if (card.classList.contains('nq-has-rating-badge')) return;

    var media = card.querySelector('.card-media');
    if (!media) return;

    var data = parseRating(card);
    if (!data) return;

    var badge = document.createElement('div');
    badge.className = 'nq-card-rating';

    // One decimal, matching how review scores are normally shown.
    var shown = (Math.round(data.value * 10) / 10).toFixed(1);

    badge.innerHTML =
      STAR +
      '<span class="nq-card-rating__value">' + shown + '</span>' +
      (data.count ? '<span class="nq-card-rating__count">(' + data.count + ')</span>' : '');

    media.appendChild(badge);
    card.classList.add('nq-has-rating-badge');
  }

  function run(root) {
    (root || document).querySelectorAll('.card--product').forEach(decorate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); });
  } else {
    run();
  }

  // Collection pages use infinite scroll and the quick-add drawer re-renders
  // cards, so newly injected cards need decorating too.
  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; run(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
